//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Grid, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import { useLocation } from 'react-router';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { List as LINQ } from "linqts";
import _ from "lodash";
import ChangeOrderCustom from 'components/System/ChangeOrderCustom';
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ProjectSectionArrangeOrder = ({ isPermission, nSectionID, lstProjectSectionType, setlstProjectSectionType }) => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const handleChangeOrder = (nNewOrder, nOldOrder, arrArrangeOrder, nTotalWeightScore) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmChangeOrder", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();

            // - ระบบจะดักไว้กรณีที่ทางเลขาเรียงลำดับคะแนนน้อยกว่าไปอยู่ลำดับสูงกว่าคะแนนที่มากกว่า จะแสดงข้อความแจ้งเตือนและไม่สามารถเลือกคะแนนน้อยกว่าไปอยู่ลำดับสูงกว่าได้
            // - กรณีที่คะแนนได้ 70 เท่ากัน และวงเงินไม่เท่ากัน ระบบจะแสดงโครงการที่ใช้เงินน้อยกว่าแสดงขึ้นมาก่อน และเลขาแก้ไขลำดับได้ภายหลัง
            let isWarning = false;
            let sWarning = "";
            let objTotalWeightScore = arrArrangeOrder.find((f) => f.nOrder === nNewOrder);
            if (nTotalWeightScore < objTotalWeightScore.nTotalWeightScore) // - คะแนน น้อยกว่า จะไม่ให้ขึ้นเกืน คะแนนที่มากกว่า 
            {
                isWarning = true;
                sWarning = "ไม่สามารถเลือกโครงการที่มีคะแนนเฉลี่ยน้อยกว่าไปอยู่ลำดับที่สูงกว่าได้";
            }
            else if (nTotalWeightScore > objTotalWeightScore.nTotalWeightScore) // - คะแนน มากกว่า จะไม่ให้ลดมา น้อยกว่า ได้
            {
                isWarning = true;
                sWarning = "ไม่สามารถเลือกโครงการที่มีคะแนนเฉลี่ยสูงกว่าไปอยู่ลำดับที่น้อยกว่าได้";
            }            
            if (isWarning) 
            {
                DialogFn.UnBlockUI();
                return DialogFn.Warning(sWarning);
            }

            let objSelf = arrArrangeOrder.find((f) => f.nOrder === nOldOrder);
            //Order ใหม่มากกว่าเก่า
            if (nNewOrder > nOldOrder) {
                //เคสที่มากกว่าตัวเอง
                let arrChange = arrArrangeOrder.filter(
                    (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
                );
                arrChange.forEach((f) => {
                    f.nOrder--;
                });
            } else {
                //Order ใหม่น้อยกว่าเก่า
                //เคสที่น้อยกว่าตัวเอง
                let arrChange = arrArrangeOrder.filter(
                    (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
                );
                arrChange.forEach((f) => {
                    f.nOrder++;
                });
            }
            //อัพเดทตัวเอง
            objSelf.nOrder = nNewOrder;
            //เรียงลำดับ
            arrArrangeOrder.slice().sort((a, b) => a.nOrder - b.nOrder);
            let lstDataArrangeOrder = new LINQ<any>(arrArrangeOrder).OrderBy(o=> o.nOrder).ToArray();

            setlstProjectSectionType(lstDataArrangeOrder);
            // setlstProjectSectionType(value => [...value]);
            
            handleSubmitChangesOrder(arrArrangeOrder);
        });
    };

    const handleSubmitChangesOrder = (arrArrangeOrder) => {
        let param = {
            nSectionID: nSectionID,
            lstArrangeOrder: arrArrangeOrder ?? [],
        };     
        AxiosFn.Post(ApiProject.SaveProjectChangesOrder, param, (result) => {
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.SaveChangeOrderComplete", I18NextNs.labelComponent), () => {});
        }, (err) => {
            DialogFn.UnBlockUI();
            if (!err.response) DialogFn.Warning(err.sMessage);
        });       
    };

    return (
        <TableContainer id={'table-SectionArrangeOrder-' + nSectionID} component={Paper}>
            <Table sx={{ minWidth: 1000 }}>
                <TableHead>
                    <TableRow>
                    <TableCell component="th" padding='none' style={{ minWidth: '180px', width: '180px' }} >ชื่อโครงการ</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '140px', width: '140px', }} >หน่วยงาน</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนที่ได้ <br/>(รวม)")}</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >เฉลี่ยคะแนนที่ได้</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }} >{ParseHtml("วงเงินงบประมาณ <br/>(บาท)")}</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '70px', width: '70px' }} >สรุปผล</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >จัดลำดับ</TableCell>
                    </TableRow>
                </TableHead>  
                    {(lstProjectSectionType || []).length === 0 ?
                        <StyledTableRow key={`sID_ScoreSummary_` + nSectionID}>
                            <TableCell align="center" colSpan={7} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
                        </StyledTableRow>
                        :
                        <TableBody>
                            {(lstProjectSectionType || []).map((iProject) => {
                                // let isColor = iProject.isPassCriteriaScore === true && iProject.nOrder < 3;
                                let sColor = iProject.isPassCriteriaScore === true ? 'green' : (iProject.isPassCriteriaScore === false ? 'red' : (iProject.sStatusName === "" ? '' : 'black'));
                                let sBKColor = iProject.isPassCriteriaScore === true ? '#dff1e3' : (iProject.isPassCriteriaScore === false ? '#f8caca' : (iProject.sStatusName === "" ? '' : '#aaaaaa'));
                                return (
                                    <TableRow key={`sID_ScoreSummary_${nSectionID}_${iProject.nProjectID}`}>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="left">
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2'>{iProject.sProjectName ?? ""}</Typography>
                                            </Grid>  
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="left">
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2'>{iProject.sUnitTypeName ?? ""}</Typography>
                                            </Grid>  
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="center">
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' fontWeight="bold" >{iProject.nTotalScore !== null ? formatNumber(iProject.nTotalScore + "", 0) : ""}</Typography>
                                            </Grid>                                                
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="center">
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' fontWeight="bold" >{iProject.nTotalWeightScore !== null ? formatNumber(iProject.nTotalWeightScore + "", 2) : ""}</Typography>
                                            </Grid>                                                
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="right">
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' fontWeight="bold" >{iProject.nProjectBudget !== null ? formatNumber(iProject.nProjectBudget + "", 2) : ""}</Typography>
                                            </Grid>                                                
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="center" style={{ backgroundColor: sBKColor, }}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' fontWeight="bold" style={{ color: sColor, }} >{iProject.sStatusName ?? ""}</Typography>
                                            </Grid>  
                                        </TableCell>
                                        <TableCell className={!iProject.isColor ? '' : 'bg-color'} align="center">
                                            <Grid item xs={12} md={12}>
                                                {/* iProject.nOrder */}
                                                <ChangeOrderCustom
                                                    id={"nOrder_" + iProject.nProjectID}
                                                    item={iProject}
                                                    value={iProject.nOrder}
                                                    onChangeOrder={(sID, nOrder) => handleChangeOrder(+nOrder, +iProject.nOrder, lstProjectSectionType, iProject.nTotalWeightScore)}
                                                    optOrder={new LINQ<any>(lstProjectSectionType || []).Where(w=> w.nOrder !== 0).OrderBy(o=> o.nOrder).Select(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}).ToArray() ?? []}
                                                    IsView={false}
                                                    disabled={!isPermission || iProject.isPassCriteriaScore === false || iProject.sStatusName === ""}
                                                />
                                            </Grid>  
                                        </TableCell>
                                    </TableRow>                                            
                                )
                            })}
                        </TableBody>
                    }                    
            </Table>
        </TableContainer>
    );
}
export default ProjectSectionArrangeOrder;